import { Injectable } from '@angular/core';
import { Bloc, BlocEvent, BlocState, InitEvent, ReadyState } from 'src/app/shared/bloc/base-bloc';

import { BehaviorSubject } from 'rxjs';
import { PdfReadyStatus } from 'src/app/shared/interfaces';

@Injectable({ providedIn: 'root' })
export class StatisticsPDFBloc extends Bloc<BlocEvent, BlocState> {
  public pdfReady$: BehaviorSubject<PdfReadyStatus> = new BehaviorSubject<PdfReadyStatus>({
    statisticsCommentsReady: false,
    statisticsGenderReady: false,
    statisticsMapReady: false,
    statisticsReady: false,
    statisticsScoreboardReady: false,
  });

  public exportPdfInProgress: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  constructor() {
    super();
  }
  onIncomingEvents(event: BlocEvent): void {
    if (event instanceof InitEvent) {
      this.onState$.next(new ReadyState());
    }
  }
}
